import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import RelatedNewsSliderComponent from './js/related-news.component';

dcFactory.register(RelatedNewsSliderComponent);
